import { render, staticRenderFns } from "./passwordReset.vue?vue&type=template&id=30d3d424&scoped=true&"
import script from "./passwordReset.vue?vue&type=script&lang=js&"
export * from "./passwordReset.vue?vue&type=script&lang=js&"
import style0 from "./passwordReset.vue?vue&type=style&index=0&id=30d3d424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d3d424",
  null
  
)

export default component.exports